function SocialChannel3() {
  return (
    <svg
      width={203}
      height={81}
      viewBox="0 0 203 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M188 15L156.205 64H88.8415H0.999998"
        stroke="#242536"
        strokeOpacity="0.6"
      />
      <path
        d="M188 15L156.205 64H88.8415H0.999998"
        stroke="url(#paint0_linear_2018_47)"
        strokeOpacity="0.68"
      />
      <path
        opacity="0.3"
        d="M177 1L145.359 50H78.3237H4.17233e-06"
        stroke="#242536"
      />
      <path opacity="0.3" d="M202 31L170.336 80H103.251H3.99999" stroke="#242536" />
      <defs>
        <linearGradient
          id="paint0_linear_2018_47"
          x1="120.637"
          y1="39.9153"
          x2={-220}
          y2="36.4179"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0674891" stopColor="#368DFF" stopOpacity={0} />
          <stop offset="0.207026" stopColor="#368DFF" />
          <stop offset="0.207969" stopColor="#368DFF" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>

  );
}

export default SocialChannel3;